(function () {
  var MAX_DISPLAY = 3;

  function fetchCartRecommendations() {
    var container = document.getElementById('RepDebtCartRecommendations');
    if (!container) return;
    var recUrl = container.getAttribute('data-url') || '/recommendations/products';

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          container.innerHTML = '';
          return;
        }
        var cartProductIds = cart.items.map(function (item) { return String(item.product_id); });
        var productId = cartProductIds[0];
        var params = new URLSearchParams({
          section_id: 'rep-debt-cart-recommendations',
          product_id: productId,
          limit: 6
        });
        return fetch(recUrl + '?' + params.toString())
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var recs = doc.querySelector('rep-debt-cart-recommendations');
            if (!recs) {
              container.innerHTML = '';
              return;
            }

            var items = Array.prototype.slice.call(
              recs.querySelectorAll('.rep-debt-cart-recs__item')
            );

            // Exclude products already in the cart and unavailable products.
            items.forEach(function (item) {
              var pid = item.getAttribute('data-product-id');
              var available = item.getAttribute('data-available');
              if (cartProductIds.indexOf(pid) !== -1 || available === 'false') {
                item.remove();
              }
            });

            // Trim to a compact, consistent display count.
            var remaining = Array.prototype.slice.call(
              recs.querySelectorAll('.rep-debt-cart-recs__item')
            );
            remaining.forEach(function (item, index) {
              if (index >= MAX_DISPLAY) {
                item.remove();
              }
            });

            var finalCount = recs.querySelectorAll('.rep-debt-cart-recs__item').length;
            if (finalCount > 0) {
              container.innerHTML = recs.outerHTML;
            } else {
              container.innerHTML = '';
            }
          });
      })
      .catch(function () {
        container.innerHTML = '';
      });
  }

  document.addEventListener('DOMContentLoaded', fetchCartRecommendations);
  document.addEventListener('cart-drawer:open', fetchCartRecommendations);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartRecommendations);
  }
})();
